import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faTriangleExclamation, faFerry } from "@fortawesome/free-solid-svg-icons";

const TrafficItem = ({ item }) => {
  const { loc_description, description, categories, loc_sortroadnumber } = item.properties;

  // Bestimme das passende Icon
  let icon;
  if (categories.includes("Stau")) {
    icon = faCar;
  } else if (categories.includes("Gefahr")) {
    icon = faTriangleExclamation;
  } else if (categories.includes("Fähre")) {
    icon = faFerry;
  } else {
    icon = faTriangleExclamation; // Standard-Icon setzen, falls keine Kategorie passt
  }

  return (
    <div className="trafficItem">
      <div className="trafficItemRoad">
        <FontAwesomeIcon icon={icon} size="2x" style={{ color: "#fffcfc" }} />
        <p className="roadNumber">{loc_sortroadnumber && `${loc_sortroadnumber}`}</p>
      </div>
      <div className="trafficItemContent">
        <h3>{loc_description}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default TrafficItem;
